import axios from "axios";
import { I18n } from "react-redux-i18n";
import {
  ADDRESS_LIST_ATTEMPT,
  ADDRESS_LIST_SUCCESS,
  ADDRESS_LIST_FAILED,
  ///////////////////////
  ADDRESS_SAVE_ATTEMPT,
  ADDRESS_SAVE_SUCCESS,
  ADDRESS_SAVE_FAILED,
} from "../types/addressTypes";
import { config } from "../../config";

const url_api = config.api.godiway;

export function loading() {
  return { type: ADDRESS_LIST_ATTEMPT };
}

export function success(data) {
  return { type: ADDRESS_LIST_SUCCESS, data };
}

export function failed(error) {
  return { type: ADDRESS_LIST_FAILED, error };
}

export function saving() {
  return { type: ADDRESS_SAVE_ATTEMPT };
}

export function saveSuccess(data) {
  return { type: ADDRESS_SAVE_SUCCESS, data };
}

export function saveFailed(error) {
  return { type: ADDRESS_SAVE_FAILED, error };
}

export const loadList = (data: Object) => async (dispatch) => {
  dispatch(loading());
  try {
    const response = await axios.get(url_api + "address", {
      params: { id: data.user_id, lang: I18n.t("locale") },
      headers: { Authorization: `Bearer ${data.token}` },
    });

    if (response.status < 300 && response.data.status === "Success") {
      dispatch(success(response.data.body));
    } else {
      dispatch(failed(response.data.body || "try_later"));
    }
  } catch (error) {
    dispatch(failed("try_later"));
  }
};

export const newItem = (data: Object) => async (dispatch) => {
  dispatch(saving());
  try {
    const response = await axios.post(
      url_api + "address",
      { ...data.params, id: data.user_id },
      { headers: { Authorization: `Bearer ${data.token}` } }
    );

    if (response.status < 300 && response.data.status === "Success") {
      dispatch(saveSuccess(response.data.body));
      return { ok: true, data: response.data.body };
    }
    dispatch(saveFailed(response.data.body || "try_later"));
    return { ok: false, error: response.data.body };
  } catch (error) {
    dispatch(saveFailed("try_later"));
    return { ok: false, error: "try_later" };
  }
};

export const updateItem = (data: Object) => async (dispatch) => {
  dispatch(saving());
  try {
    const response = await axios.put(
      url_api + "address",
      { ...data.params, id: data.user_id },
      { headers: { Authorization: `Bearer ${data.token}` } }
    );

    if (response.status < 300 && response.data.status === "Success") {
      dispatch(saveSuccess(response.data.body));
      return { ok: true, data: response.data.body };
    }
    dispatch(saveFailed(response.data.body || "try_later"));
    return { ok: false, error: response.data.body };
  } catch (error) {
    dispatch(saveFailed("try_later"));
    return { ok: false, error: "try_later" };
  }
};

export const removeItem = (data: Object) => async (dispatch) => {
  dispatch(saving());
  try {
    const response = await axios.delete(url_api + "address", {
      headers: { Authorization: `Bearer ${data.token}` },
      data: { id: data.user_id, address_id: data.address_id },
    });

    if (response.status < 300 && response.data.status === "Success") {
      dispatch(saveSuccess(response.data.body));
      return { ok: true };
    }
    dispatch(saveFailed(response.data.body || "try_later"));
    return { ok: false, error: response.data.body };
  } catch (error) {
    dispatch(saveFailed("try_later"));
    return { ok: false, error: "try_later" };
  }
};
